import React from "react";
import { Flex, Text, Heading, Box } from "@sparrowengg/twigs-react";
import { NoDataProps } from "commons/types";
import { Gradient } from "commons/icons/gradient";

const Fallback = ({
  title,
  description,
  icon,
  children,
  containerStyles,
  isBlackTheme = false,
  isLoader,
  gradientColor = "#56B0BB"
}: NoDataProps) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      css={{
        width: "100%",
        height: isLoader ? "100%" : "auto"
      }}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        gap="$16"
        css={{ width: '100%',maxWidth: "570px", ...containerStyles }}
      >
        <Flex
          flexDirection="column"
          css={{
            textAlign: "center",
            width: '100%'
          }}
        >
          <Flex
            alignItems="end"
            justifyContent="center"
            css={{
              position: 'relative',
              height: '$20',
              overflow: 'hidden',
              borderTop: '1px solid',
              borderImageSource:
                'linear-gradient(90deg, rgba(100, 116, 139, 0) 15.02%, rgba(100, 116, 139, 0.15) 50.54%, rgba(100, 116, 139, 0) 85.77%)',
              '& .gradient': {
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                bottom: '-117px',
              },
            }}
          >
            <Flex
              alignItems="center"
              justifyContent="center"
              css={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                background: isBlackTheme ? isLoader ? "$black900" : "#151515" : "$white900",
                borderWidth: "$borderWidths$xs",
                borderStyle: "solid",
                borderColor: "rgba(113, 88, 245, 0.06)",
                width: "$20",
                height: "77px",
                borderBottom: "none",
                borderRadius: "$2xl $2xl 0 0",
                zIndex: 2
              }}
            >
              {icon}
            </Flex>
            <Gradient color={gradientColor} />
          </Flex>
          <Box
            css={{
              height: '1px',
              width: '100%',
              marginBottom: '$16',
              backgroundImage:
                'linear-gradient(90deg, rgba(100, 116, 139, 0) 15.02%, rgba(100, 116, 139, 0.15) 50.54%, rgba(100, 116, 139, 0) 85.77%)',
            }}
          />
          {!!title && (
            <Heading size="h5" weight="medium" css={{  marginTop: "$4", color: isBlackTheme ? "$white900" : "$neutral900", alignSelf: 'center' }}>
              {title}
            </Heading>
          )}
          {!!description && (
            <Text size="md" css={{ maxWidth: 376, marginTop: "$4",color: isBlackTheme ? "$white800" : "$neutral800", alignSelf: 'center'  }}>
              {description}
            </Text>
          )}
        </Flex>
        {children}
      </Flex>
    </Flex>
  );
};

export default Fallback;
